const env = import.meta.env as Record<string, string | undefined>;

/** Coordonnées de la plateforme affichées sur le site public (réglables dans le fichier .env du site). */
export const CONTACT = {
  email: env.VITE_CONTACT_EMAIL || "sanoismael51@gmail.com",
  phone: env.VITE_CONTACT_PHONE || "+224 628 01 34 77",
  city: env.VITE_CONTACT_CITY || "Conakry, Guinée",
};
